import { config } from '@iheartjane/config';
import type {
  DefinedUseQueryResult,
  UseQueryResult,
} from '@tanstack/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';

/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';

import { api } from '../api/api';
import { queryKeys } from './stores.util';

type StoreId = number | string;

const storeUrl = (storeId: StoreId) => `${config.apiPath}/stores/${storeId}`;

const getStore = async <TStore = Store>(id: StoreId) =>
  api.get<{ store: TStore }>(storeUrl(id)).then((result) => result.store);

export const getStoreQueryOptions = <TStore = Store>(id: StoreId | undefined) =>
  queryOptions({
    // `enabled` gates the fetch; `id` is always defined by the time queryFn runs
    enabled: !!id,
    queryFn: () => getStore<TStore>(id!),
    queryKey: queryKeys.store(id!),
  });

export function useGetStore<TStore = Store>(
  id: StoreId | undefined
): UseQueryResult<TStore>;

export function useGetStore<TStore = Store>(
  id: StoreId | undefined,
  options: { initialData: TStore }
): DefinedUseQueryResult<TStore>;

export function useGetStore<TStore = Store>(
  id: StoreId | undefined,
  options?: { initialData: TStore }
) {
  return useQuery({ ...getStoreQueryOptions<TStore>(id), ...options });
}
